export default __webpack_public_path__ + "static/media/icon_warning.57204b49.svg";